module.exports = __webpack_public_path__ + "static/media/newYear.ed02c79f.pdf";